import { Injectable, inject } from '@angular/core';
import { ApiService } from '@cropx-web/services/network/ApiService';
import {
  Action,
  State,
  StateContext,
  Store,
  createPropertySelectors,
} from '@ngxs/store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FieldMapView {
  const type = 'FieldMapView';

  export class SetFieldId {
    static readonly type = `[${type}] SetFieldId`;
    constructor(public fieldId: string) {}
  }

  export class SetActiveDataset {
    static readonly type = `[${type}] SetActiveDataset`;
    constructor(public datasetUuid: string) {}
  }

  export class SetActiveMeasurement {
    static readonly type = `[${type}] SetActiveMeasurement`;
    constructor(public measurementId: number) {}
  }

  export class SetMachineDataOpacity {
    static readonly type = `[${type}] SetOpacity`;
    constructor(public opacity: number) {}
  }
}

export interface FieldMapViewStateModel {
  datasetUuid: string;
  measurementId: number;
  fieldUuid: string;
  machineDataOpacity: number;
  activeMachineDataDate: string;
}

@State<FieldMapViewStateModel>({
  name: 'fieldMapView',
  defaults: {
    datasetUuid: '',
    measurementId: 0,
    fieldUuid: '',
    machineDataOpacity: 1,
    activeMachineDataDate: '',
  },
})
@Injectable()
export class FieldMapViewState {
  private store = inject(Store);
  private oldApi = inject(ApiService);

  @Action(FieldMapView.SetFieldId)
  setField(
    ctx: StateContext<FieldMapViewStateModel>,
    action: FieldMapView.SetFieldId,
  ): void {
    ctx.patchState({
      fieldUuid: action.fieldId,
    });
  }

  @Action(FieldMapView.SetActiveDataset)
  setActiveDataset(
    ctx: StateContext<FieldMapViewStateModel>,
    action: FieldMapView.SetActiveDataset,
  ): void {
    ctx.patchState({
      datasetUuid: action.datasetUuid,
      measurementId: 0,
    });
  }

  @Action(FieldMapView.SetActiveMeasurement)
  setActiveMeasurement(
    ctx: StateContext<FieldMapViewStateModel>,
    action: FieldMapView.SetActiveMeasurement,
  ): void {
    ctx.patchState({
      measurementId: action.measurementId,
    });
  }

  @Action(FieldMapView.SetMachineDataOpacity)
  setMachineDataOpacity(
    ctx: StateContext<FieldMapViewStateModel>,
    action: FieldMapView.SetMachineDataOpacity,
  ): void {
    ctx.patchState({
      machineDataOpacity: action.opacity,
    });
  }
}

export class FieldMapViewSelectors {
  static slices =
    createPropertySelectors<FieldMapViewStateModel>(FieldMapViewState);
}
